import * as React from 'react';

import { Box } from '@mantine/core';

import { ExperimentsList } from './ExperimentsList';
import { HEADER_HEIGHT } from '../constants/layout-constants';

export function ExperimentOverview() {
  return (
    <Box style={{ height: `calc(100vh - ${HEADER_HEIGHT}px)`, overflowY: 'auto' }}>
      <ExperimentsList />
    </Box>
  );
}
